import { CompanyResource } from "@/graphql/generated/graphql";
import { Tooltip } from "@mui/material";
import { GridColDef, GridRenderCellParams } from "esseal-data-table";
import { titleize } from "inflection";

const equipmentColumns: GridColDef<CompanyResource>[] =
  [
    {
      field: "name",
      headerName: "Name",
      width: 350,
      renderCell: ({ row }: GridRenderCellParams) =>
        <Tooltip title={row.name}>
          <span>{row.name}</span>
        </Tooltip>
    },
    {
      field: "shortCode",
      headerName: "Short Code",
      width: 350,
      valueGetter: (row) => row.resourceMeta?.shortCode || "",
      renderCell: ({ row }: GridRenderCellParams) =>
        <Tooltip title={row.resourceMeta?.shortCode || "-"}>
          <span>{row.resourceMeta?.shortCode || "-"}</span>
        </Tooltip>
    },
    {
      field: "equipmentType",
      headerName: "Equipment Type",
      width: 350,
      valueGetter: (row) => row.resourceMeta?.equipmentType || "",
      renderCell: ({ row }: GridRenderCellParams) =>
        <Tooltip title={row.resourceMeta?.equipmentType || "-"}>
          <span>{row.resourceMeta?.equipmentType ? titleize(row.resourceMeta?.equipmentType) : "-"}</span>
        </Tooltip>
    },
    {
      field: "status",
      headerName: "Status",
      width: 350,
      valueGetter: (row) => row.resourceMeta?.status || "",
      renderCell: ({ row }: GridRenderCellParams) =>
        <Tooltip title={row.resourceMeta?.status || "-"}>
          <span>{row.resourceMeta?.status ? titleize(row.resourceMeta?.status) : "-"}</span>
        </Tooltip>
    },
  ];

export default equipmentColumns;
